import React, { useRef } from 'react';

import classNames from 'classnames';

import { useIsShowed } from 'hooks/useIsShowed';

import { useFindPaddings } from '../hooks/useFindPaddings';
import CircleDotted from '../icons/CircleDotted.svg';

import './CircledDottedScheme.scss';

export interface CircledDottedSchemeProps {
  items: string[];
  innerTitle?: string;
  containerClass?: string;
  innerIcon?: React.ReactElement;
  parseHtml?: boolean;
  isReversed?: boolean;
  size?: 'small' | 'medium' | 'large' | 'extra-large';
  hasCircledIcon?: boolean;
}

export const CircledDottedSchemeDesktop = ({
  items,
  innerTitle,
  containerClass = '',
  innerIcon,
  parseHtml = false,
  isReversed = false,
  size = 'large',
  hasCircledIcon = false,
}: CircledDottedSchemeProps) => {
  const [svgRef, isShow] = useIsShowed();
  const schemeElement = useRef<HTMLDivElement>(null);
  const [paddingTop, paddingBottom] = useFindPaddings(schemeElement, items.length, isReversed);

  return (
    <div
      ref={schemeElement}
      className={`circled-dotted-scheme-container ${containerClass}`}
      style={{ paddingTop: `${paddingTop}px`, paddingBottom: `${paddingBottom}px` }}
    >
      <div
        className={classNames(`circled-dotted-scheme circled-dotted-scheme-${items.length}`, size, {
          reversed: isReversed,
        })}
      >
        <CircleDotted className="circled-dotted-scheme-background-svg" />
        {items.map((text, index) => (
          <div key={text} className={classNames(`circled-dotted-scheme-item-${index}`, 'circled-dotted-scheme-item')}>
            <div
              className={classNames(`circled-dotted-scheme-dot-${index}`, 'circled-dotted-scheme-dot', {
                show: isShow,
              })}
            />
            {parseHtml && (
              <div
                className={`circled-dotted-scheme-text circled-dotted-scheme-text-${index}`}
                dangerouslySetInnerHTML={{
                  __html: text,
                }}
              />
            )}
            {!parseHtml && <p className={`circled-dotted-scheme-text caption dotted-text-${index}`}>{text}</p>}
          </div>
        ))}

        <div
          ref={svgRef}
          className={classNames(
            { 'svg-border-gradient svg-circle': innerTitle || hasCircledIcon },
            'circled-dotted-scheme-inner',
          )}
        >
          {innerIcon}
          <p className="scheme-title circled-dotted-scheme-title">{innerTitle}</p>
        </div>
      </div>
    </div>
  );
};
